// Source count-up behavior, scoped to transferred sections and safe on editor reloads.
class RHGarlicCounts extends HTMLElement {
  #observer;
  #frames = new Set();
  connectedCallback() {
    this.#observer?.disconnect();
    for (const metric of this.querySelectorAll('.fact > strong')) {
      const match = metric.textContent.trim().match(/^(\d+(?:\.\d+)?)/);
      if (match) metric.dataset.count = match[1];
    }
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    this.#observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        const element = entry.target;
        this.#observer.unobserve(element);
        const end = Number(element.dataset.count);
        if (!element.dataset.count || !Number.isFinite(end)) continue;
        const finalText = element.textContent;
        const start = performance.now();
        const decimal = (String(end).split('.')[1] || '').length;
        const tick = (now) => {
          if (!this.isConnected) return;
          const progress = Math.min((now - start) / 600, 1);
          element.textContent = progress === 1 ? finalText : finalText.replace(/\d[\d,.]*/, (end * (1 - (1 - progress) ** 3)).toLocaleString('en-US', {minimumFractionDigits: decimal, maximumFractionDigits: decimal}));
          if (progress < 1) this.#schedule(tick);
        };
        this.#schedule(tick);
      }
    }, {threshold: .4});
    for (const element of this.querySelectorAll('[data-count]')) this.#observer.observe(element);
  }
  #schedule(callback) {
    const frame = requestAnimationFrame((now) => {this.#frames.delete(frame);callback(now);});
    this.#frames.add(frame);
  }
  disconnectedCallback() {
    this.#observer?.disconnect();
    for (const frame of this.#frames) cancelAnimationFrame(frame);
    this.#frames.clear();
  }
}
if (!customElements.get('rh-garlic-counts')) customElements.define('rh-garlic-counts', RHGarlicCounts);
